import env from 'utils/env';

// AQSN-5108: sign-in, sign-up and password reset go through Universal Login,
// as on vn.elsaspeak.com/user/login. On production it sets the auth_data cookie
// on .elsaspeak.com, which hooks/useSession reads on the way back to /user.
// Staging (id-stg.elsanow.co) sets it on .elsanow.co and does not accept
// jp-stag.elsaspeak.com as a redirect, so signing in cannot be tried there.
const getRedirectUrl = () => {
  const defaultRedirectUrl = `${window.location.origin}/user`;
  const redirect = new URLSearchParams(window.location.search).get('redirect');
  return encodeURIComponent(redirect ? defaultRedirectUrl + redirect : defaultRedirectUrl);
};

export const getUniversalLoginUrl = (path = '') => {
  const { universalLoginUrl, universalLoginClientId } = env();
  return `${universalLoginUrl}${path}?clientId=${universalLoginClientId}&redirectUrl=${getRedirectUrl()}&lng=ja`;
};

export const getUniversalResetPasswordUrl = () => getUniversalLoginUrl('/forgot-password');
